import { IconButton, Modal,ContextualMenu,mergeStyleSets, PrimaryButton, DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import React, { useEffect, useState,useContext,useRef } from "react";
import $ from "jquery";
import "./modalStyle.css";
import { generateRSNAReport, getSelectionsForRSNAFunc, handleChangeValues, updateRSNAReport } from "../../../helper/RSNAUtilities";
import { generateRSNADynamicReport, getHTMLTemplate } from "../../../../../service/StudyReportService";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import { circlStyle } from "../../../helper/initialData";
import 'jquery-ui-bundle';
import { CUSTOM_STYLES } from "../../../../../constants/Constants";
import themeContext from "../../../../../context/theme/ThemeContext";
import { iconButtonStylesFunc } from "../../../../../components/Modal/ModalHeader";

const RSNAModal = (props) => {

  const [htmlContent,setHTMLContent] = useState();
  const [loading,setLoading] = useState(false);
  const { getThemeColor,getAlterColor,themeName,getScrollBarStyleForTheme } = useContext(themeContext);
  const [resetClicked, setResetClicked] = useState(false);
  const containerRef = useRef(null);
  const {
    generateRSNAReportAPICall,
    alertSuccessModal,setAlertSuccessModal
  } = useContext(studyReportContext);

  const getHTMLTemplateCall = async(id)=>{
    setLoading(true);
    let res = await getHTMLTemplate(id);
    // console.log("Resposne HTML ");
    // console.log(res);
    if(res.status == 200){
      if(res.data.result == "SUCCESS"){
        let content = res.data.data.report;
        setHTMLContent(content);
        setTimeout(()=>{
          setResetClicked(prev=>!prev);
        },100)
        setLoading(false);
      }else{
        setLoading(false);
      }
    }
  }

  useEffect(()=>{
    if(htmlContent != null && htmlContent != undefined && htmlContent != ""){
       if(props.content.text != "TUBERCULOSIS"){
          if( document.getElementById("DATE_1542586542564") != null){
            document.getElementById("DATE_1542586542564").type = 'date';
          } 
          updateRSNAReport();
          $('.accordion').sortable();
          $('#findings_div').sortable();
          $("#rsna-title").text(props.content.text.replace("SR", ""));
          handleChangeValues(null,props);
       }
       $("#rsnaPopupContext").trigger("click");
    }
},[htmlContent]);

  useEffect(()=>{
      if(props.content.key != null && props.content.key != undefined){
          getHTMLTemplateCall(props.content.key);
      }
  },[props.content.key])
    const contentStyles = {
        container: {
          display: 'flex',
          width:'500px',
          overflowY:'hidden',
          overflowX:'hidden',
          borderRadius:'10px',
          backgroundColor: getAlterColor("rgb(22, 21, 20)","white"),
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
          border: CUSTOM_STYLES.MODAL_BORDER,
        },
        scrollableContent:{
            overflowY:'hidden'
        },
        header:
          {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px',
            cursor:'pointer'
          },
        footer:
            {
                display: 'flex',
                justifyContent:"space-between",
                background: getThemeColor("modal-header-footer"),
                padding: '10px'
            }
        ,
        heading: {
            color:'white',
            fontSize: 'inherit',
            margin: '0',
        },
        body: {
            overflowY:'auto',
            height:'89.5%',
            paddingLeft:'10px',
            paddingRight:'10px',
            background: '#00000000',
            color: 'white'
        }
      };

    const iconButtonStyles = {
        root: {
          marginLeft: 'auto',
          marginTop: '4px',
          marginRight: '2px',
        },
        rootHovered: {
        },
      };
    
    const cancelIcon = { iconName: 'Cancel' }; 



function getSelectionsForRSNA() {
      
  let response = getSelectionsForRSNAFunc();
  if(response.error != null || response.error != undefined){
    setAlertSuccessModal(()=>{
      const newItem = {...alertSuccessModal};
      newItem.show = true;
      newItem.heading = "Alert";
      newItem.isError = false;
      newItem.isSuccess = false;
      newItem.isWarning = true;
      newItem.description = response.message;
      return newItem;
    });
    return;
  }
    generateRSNAReportAPICall(response,props);
  };

  function resetRSNAForm() {
    getHTMLTemplateCall(props.content.key);
  }

  useEffect(() => {
    if (containerRef.current) {
      const elements = containerRef.current.querySelectorAll('.rsna-body select, .rsna-body textarea, .rsna-body input');
      if (elements.length > 0) {
        elements.forEach(element => {
          element.style.backgroundColor = getThemeColor("modal-body");
          element.style.color = getThemeColor("primary-color");
        });
      }
    }
  }, [htmlContent,containerRef,resetClicked]);


  useEffect(()=>{
    $(".modal-overlay").draggable({
        handle: ".modal-header"
      });
  },[htmlContent])

    return (
        <>



         {loading &&  <Spinner size={SpinnerSize.large} styles={circlStyle}/>}
        {!loading && props.isModalOpen && <>

          <div className="modal-overlay" style={contentStyles.container}>
          <div
            className="modal-content-react"
            style={{width:'100%'}}
          >
            <div className="modal-header"  style={{...contentStyles.header, background:  getThemeColor("modal-header-footer"),}}>
            {props.content.text}
            <IconButton
              styles={iconButtonStylesFunc(getThemeColor)}
              iconProps={cancelIcon}
              ariaLabel="Close popup modal"
              onClick={props.hideModal}
            />
            </div>
            <div style={{background:  getThemeColor("modal-body")}} className="modal-body-react">

            <div  ref={containerRef} id="rsnaPopupContext" style={{color: getThemeColor("primary-color"),backgroundColor: getThemeColor("modal-body"),accentColor:'rgb(0,117,255)'}}  onClick={(e)=>{handleChangeValues(e,props)}} className={`rsna-body ${getScrollBarStyleForTheme(themeName,"modal-scroll-rsna")}`} 
        dangerouslySetInnerHTML={{__html: htmlContent}}
        >
        </div>
        <div style={contentStyles.footer}>
            <div style={{display:'flex'}}>
                <DefaultButton text="Cancel" onClick={props.hideModal} />
                <PrimaryButton style={{marginLeft:'10px'}} text="Reset" onClick={()=>resetRSNAForm()} />
            </div>
           
            <PrimaryButton text="Regenerate" onClick={()=>{
              props.content.text == "TUBERCULOSIS"?props.regenerateClick(props.content.text)
              :getSelectionsForRSNA();
              }} />
           
        </div>

            </div>
          </div>
        </div>
        </>}
        </>
    )
}

export default RSNAModal;